import app from './app';
import solar from './solar';
import tips from './tips';

export default {
  ...app,
  ...tips,
  ...solar,
};
